import { render, staticRenderFns } from "./FaqSection.vue?vue&type=template&id=6da097b3&scoped=true"
import script from "./FaqSection.vue?vue&type=script&lang=js"
export * from "./FaqSection.vue?vue&type=script&lang=js"
import style0 from "./FaqSection.vue?vue&type=style&index=0&id=6da097b3&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da097b3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/dev.ideabuddy.com/public_html/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6da097b3')) {
      api.createRecord('6da097b3', component.options)
    } else {
      api.reload('6da097b3', component.options)
    }
    module.hot.accept("./FaqSection.vue?vue&type=template&id=6da097b3&scoped=true", function () {
      api.rerender('6da097b3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Payment/Components/Sections/Faq/FaqSection.vue"
export default component.exports